// Utilities
import React, { useState, useMemo } from 'react'

// Assets
import { FaArrowRight, FaArrowLeft, FaMedal, FaTrophy } from 'react-icons/fa'

const Ranking = React.memo(({ rankingData, currentUser }) => {
  const usersPerPage = 10
  const numberOfPages = Math.ceil(rankingData.length / usersPerPage)

  const [selectedPage, setSelectedPage] = useState(0)

  const currentUserData = useMemo(
    () =>
      rankingData
        .map((user, index) => ({ ...user, index }))
        .find(user => user.nickname === currentUser),
    [rankingData, currentUser],
  )

  const dataOnPage = useMemo(
    () =>
      rankingData.slice(
        usersPerPage * selectedPage,
        usersPerPage * (selectedPage + 1),
      ),
    [selectedPage, rankingData],
  )

  const tableHeader = (
    <thead className="bg-primary text-over-primary">
      <tr>
        <th className="py-2">Nr.</th>
        <th className="py-2">Nume</th>
        <th className="py-2">Timp de rezolvare</th>
        <th className="py-2">Notă</th>
      </tr>
    </thead>
  )

  function getPlaceContentAndColor(place) {
    if (place === 1) return { content: <FaTrophy />, color: 'text-[#FFD700]' }
    if (place === 2) return { content: <FaMedal />, color: 'text-gray-400' }
    if (place === 3) return { content: <FaMedal />, color: 'text-orange-500' }
    return { content: place, color: '' }
  }

  function getRowBackgroundColor(index) {
    return index % 2 === 0 ? 'bg-secondary-background' : 'bg-ternary-background'
  }

  return (
    <div className="h-full w-[80%] flex items-center flex-col">
      <p className="text-over-primary-background my-2 text-lg">
        Rezultatele simulării anterioare
      </p>
      <div className="w-full rounded-lg overflow-hidden">
        <table className="w-full text-center text-sm text-over-primary-background">
          {tableHeader}
          <tbody>
            {dataOnPage.map((user, index) => {
              const place = index + 1 + usersPerPage * selectedPage
              const backgroundColor = getRowBackgroundColor(index)
              const { content, color } = getPlaceContentAndColor(place)

              return (
                <tr
                  key={place}
                  className={`${backgroundColor} ${color} ${
                    currentUserData &&
                    user.nickname === currentUserData.nickname &&
                    '!bg-primary text-over-primary !font-bold'
                  } h-[28px] font-medium`}
                >
                  <td className="text-center flex items-center justify-center h-[inherit]">
                    {content}
                  </td>
                  <td>{user.nickname}</td>
                  <td>{user.time}</td>
                  <td>{user.grade}</td>
                </tr>
              )
            })}
            {currentUserData &&
              (currentUserData.index < usersPerPage * selectedPage ||
                currentUserData.index >= usersPerPage * (selectedPage + 1)) && (
                <tr className="bg-primary text-over-primary font-bold h-[28px]">
                  <td className="text-center flex items-center justify-center h-[inherit]">
                    {currentUserData.index + 1}
                  </td>
                  <td>{currentUserData.nickname}</td>
                  <td>{currentUserData.time}</td>
                  <td>{currentUserData.grade}</td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
      <div className="flex flex-row mt-2">
        <button
          aria-label="Pagina anterioară"
          disabled={selectedPage === 0}
          className={`px-2 ${selectedPage === 0 && 'opacity-50'}`}
          onClick={() => setSelectedPage(prev => prev - 1)}
        >
          <FaArrowLeft
            className={`fill-over-primary-background h-[15px] ${
              selectedPage === 0
                ? 'hover:fill-over-primary-background'
                : 'hover:fill-primary'
            }`}
          />
        </button>
        <p className="text-over-primary-background">{selectedPage + 1}</p>
        <button
          aria-label="Pagina următoare"
          disabled={selectedPage >= numberOfPages - 1}
          className={`px-2 ${
            selectedPage >= numberOfPages - 1 ? 'opacity-50' : ''
          }`}
          onClick={() => setSelectedPage(prev => prev + 1)}
        >
          <FaArrowRight
            className={`fill-over-primary-background h-[15px] ${
              selectedPage >= numberOfPages - 1
                ? 'hover:fill-over-primary-background'
                : 'hover:fill-primary'
            }`}
          />
        </button>
      </div>
    </div>
  )
})

export default Ranking
